

import Vue from "vue";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";

@Component({})
export default class LockerStatusChip extends Vue {

  @Prop()
  protected status!: string;

  protected statusColors: any = {
    'Deleted': 'gray',
    'Online': 'green',
    'Off': 'red',
    'Install': 'orange',
  };

  protected clicked($e: any) {
    this.$emit('click', $e);
  }

}

